import cls from "./NotFound.module.scss";

const NotFound = () => {
  return <div className={cls.notFound}>404 PAGE NOT FOUND</div>;
};

export default NotFound;
